import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

gsap.registerPlugin(Flip);

const jobListContainers = document.querySelectorAll('.jobs-list-container');

jobListContainers.forEach(container => {
    const jobList = container.querySelector('.jobs-list');
    const jobListItems = jobList.querySelectorAll('.jobs-list__job');
    const noResults = container.querySelector('.jobs-no-results');

    const filterForm = container.querySelector('.job-filter');

    filterForm.addEventListener('change', e => {
        const activeCategories = Array.from(
            filterForm.querySelectorAll('.category-filter__input:checked'),
        ).map(input => input.value);

        const state = Flip.getState([
            ...jobListItems,
            jobList,
            noResults,
            jobList.closest('.section'),
        ]);

        jobListItems.forEach(item => {
            const categories = item.dataset.jobCategories.split(',');
            const isActive = activeCategories.length
                ? activeCategories.some(category => categories.includes(category))
                : true;
            item.style.display = isActive ? 'block' : 'none';
        });

        const hasVisibleItems = Array.from(jobListItems).some(
            item => item.style.display === 'block',
        );
        jobList.hidden = hasVisibleItems ? false : true;
        noResults.hidden = hasVisibleItems ? true : false;

        Flip.from(state, {
            duration: 0.25,
            absoluteOnLeave: jobListItems,
            onEnter: elements =>
                gsap.fromTo(elements, { opacity: 0 }, { opacity: 1, duration: 0.25 }),
            onLeave: elements => gsap.to(elements, { opacity: 0, duration: 0.25 }),
        });
    });
});
